import { IconTrash } from "@aksara-ui/icons";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogProps,
  Stack,
  Text,
  theme,
} from "@aksara-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteTierReward } from "redux/actions";

interface Props {
  tierId: string | undefined;
  tierRewardId: number;
  tierName: string | undefined;
  type: string | undefined;
}

const TierRewardConfirmationModal: React.FC<Props & DialogProps> = ({
  isOpen,
  onClose,
  tierId,
  tierRewardId,
  tierName,
  type,
}) => {
  const dispatch = useDispatch();
  const { isFormLoading } = useSelector((state: any) => state.tierReducer);

  const handleCloseModal = () => {
    onClose && onClose();
  };

  const handleDeleteTierReward = () => {
    dispatch(
      deleteTierReward(
        tierId,
        tierRewardId,
        tierName,
        type,
        handleCloseModal
      ) as any
    );
  };

  return (
    <Dialog
      disableOverlayClick
      isOpen={isOpen}
      onClose={() => handleCloseModal()}
    >
      <DialogHeader></DialogHeader>
      <DialogContent>
        <Stack
          spacing="md"
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Box
            backgroundColor={`${theme.colors.red01}`}
            size={80}
            borderRadius={100}
            display="flex"
            alignItems="center"
            justifyContent="center"
            color={`${theme.colors.red05}`}
          >
            <IconTrash size={50} fill={`${theme.colors.red05}`} />
          </Box>
          <Text scale={400}>
            Are you sure you want to delete this tier reward?
          </Text>
        </Stack>
      </DialogContent>
      <DialogFooter>
        <Stack
          display="flex"
          flexDirection="row"
          spacing="xs"
          flex={1}
          style={{ gap: 15 }}
        >
          <Button variant="outline" block onClick={() => handleCloseModal()}>
            Cancel
          </Button>

          <Button
            variant="destructive"
            block
            isLoading={isFormLoading}
            onClick={() => handleDeleteTierReward()}
          >
            Delete
          </Button>
        </Stack>
      </DialogFooter>
    </Dialog>
  );
};

export default TierRewardConfirmationModal;
